module.exports = __webpack_public_path__ + "static/media/Ancient Apparition.a288af54.png";